import useIsPaymentSystemV2Enabled from '../../modules/PaymentOrder/hooks/useIsPaymentSystemV2Enabled';
import {
  countryCodeIsIndonesia,
  countryCodeIsSingapore,
} from '../helpers/countryCodeHelper';
import useGetCompanyById from './useGetCompanyById';

export default function useIsPaymentPromoEligible(): boolean {
  const { company } = useGetCompanyById();
  const isIDCompany = countryCodeIsIndonesia(company?.CountryCode);
  const isSGCompany = countryCodeIsSingapore(company?.CountryCode);
  const isPaymentSystemV2Enabled = useIsPaymentSystemV2Enabled();

  return isIDCompany || (isSGCompany && isPaymentSystemV2Enabled);
}
